import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Card, Col, DatePicker, Row, Space, Statistic, Table, Tag, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { api } from '@/lib/api';
import { formatDate, formatRupiah } from '@/lib/format';
const BUCKET_COLOR = {
    '0-30': 'green',
    '31-60': 'gold',
    '61-90': 'orange',
    '>90': 'red',
};
export function AgingMakamPage() {
    return _jsx(AgingPage, { endpoint: "/reports/aging-makam", title: "Aging Piutang Makam" });
}
export function AgingAbuPage() {
    return _jsx(AgingPage, { endpoint: "/reports/aging-abu", title: "Aging Piutang Rumah Abu" });
}
function AgingPage({ endpoint, title }) {
    const [asOf, setAsOf] = useState(dayjs());
    const q = useQuery({
        queryKey: [endpoint, asOf.format('YYYY-MM-DD')],
        queryFn: async () => (await api.get(endpoint, {
            params: { as_of: asOf.format('YYYY-MM-DD') },
        })).data,
    });
    const cols = [
        { title: 'No. Kontrak', dataIndex: 'contract_no', width: 160 },
        { title: 'Nama', dataIndex: 'buyer_name' },
        { title: 'Petak / Lokus', dataIndex: 'plot_code', width: 140 },
        {
            title: 'Jatuh Tempo',
            dataIndex: 'due_date',
            width: 130,
            render: (v) => formatDate(v),
        },
        {
            title: 'Hari',
            dataIndex: 'days_overdue',
            width: 90,
            align: 'right',
            sorter: (a, b) => a.days_overdue - b.days_overdue,
        },
        {
            title: 'Bucket',
            dataIndex: 'bucket',
            width: 100,
            render: (v) => _jsx(Tag, { color: BUCKET_COLOR[v], children: v }),
        },
        {
            title: 'Outstanding',
            dataIndex: 'outstanding',
            width: 180,
            align: 'right',
            render: (v) => _jsx("b", { children: formatRupiah(v) }),
        },
    ];
    return (_jsxs("div", { children: [_jsxs(Space, { style: { marginBottom: 16, display: 'flex', justifyContent: 'space-between' }, children: [_jsx(Typography.Title, { level: 3, style: { margin: 0 }, children: title }), _jsx(DatePicker, { value: asOf, onChange: (v) => setAsOf(v ?? dayjs()) })] }), _jsxs(Row, { gutter: 16, style: { marginBottom: 16 }, children: [_jsx(Col, { span: 5, children: _jsx(Card, { children: _jsx(Statistic, { title: "0 \u2013 30 hari", value: parseFloat(q.data?.totals.b_0_30 ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#059669' } }) }) }), _jsx(Col, { span: 5, children: _jsx(Card, { children: _jsx(Statistic, { title: "31 \u2013 60 hari", value: parseFloat(q.data?.totals.b_31_60 ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#D97706' } }) }) }), _jsx(Col, { span: 5, children: _jsx(Card, { children: _jsx(Statistic, { title: "61 \u2013 90 hari", value: parseFloat(q.data?.totals.b_61_90 ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#EA580C' } }) }) }), _jsx(Col, { span: 5, children: _jsx(Card, { children: _jsx(Statistic, { title: "> 90 hari", value: parseFloat(q.data?.totals.b_90_plus ?? '0'), formatter: (v) => formatRupiah(Number(v)), valueStyle: { color: '#DC2626' } }) }) }), _jsx(Col, { span: 4, children: _jsx(Card, { children: _jsx(Statistic, { title: "Total", value: parseFloat(q.data?.totals.total ?? '0'), formatter: (v) => formatRupiah(Number(v)) }) }) })] }), _jsx(Card, { children: _jsx(Table, { rowKey: (r) => `${r.contract_no}-${r.due_date}`, size: "middle", pagination: { defaultPageSize: 20 }, loading: q.isLoading, columns: cols, dataSource: q.data?.rows ?? [] }) })] }));
}
